import * as ACTION from '@Bootstraps/bootstrapActions';
import * as COMPONENT from '@Components';
import * as IMG from '@Utils/Images';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import '@Styles/auth.css';

export default function Page() {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [isSame, setIsSame] = useState(false);
  const [seePassword, setSeePassword] = useState(false);
  const [error, setError] = useState(false);

  const { loginResponse, loginError } = useSelector((state) => state);
  const dispatch = useDispatch();

  function formChange(title, value) {
    setFormData((prev) => ({ ...prev, [title]: value }));
  };

  useEffect(() => {
    if (loginResponse && loginResponse.data) {
      dispatch(ACTION.setAuth(loginResponse.data));
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Success Login!',
        text: loginResponse?.access_token,
        confirmButtonColor: '#3dcd55',
        icon: 'success',
      }).then(() => window.location.reload());
    } else if (loginError) {
      setLoading(false);
      Swal.fire({
        background: '#252336',
        color: '#3dcd55',
        title: 'Failed Login!',
        text: loginError.message || 'Username or Password is Wrong!',
        confirmButtonColor: '#3dcd55',
        icon: 'error',
      });
    }
  }, [dispatch, loginResponse, loginError]);

  useEffect(() => {
    let password = document.getElementById('password');
    let confirmPassword = document.getElementById('confirmPassword');

    if (seePassword) {
      password.type = 'text';
      confirmPassword.type = 'text';
    } else {
      password.type = 'password';
      confirmPassword.type = 'password';
    }
  }, [seePassword]);

  return (
    <section className="auth">
      {error ? (
        <div
          className="alert fixed-top alert-danger alert-dismissible fade show ps-md-5 m-0"
          role="alert"
        >
          <p className="fw-bold text-danger m-0">
            Username atau Password Salah!
          </p>
          <button
            type="button"
            className="btn-close shadow-none me-md-5"
            data-bs-dismiss="alert"
            onClick={() => setError(false)}
            aria-label="Close"
          ></button>
        </div>
      ) : (
        ''
      )}
      <div className="row justify-content-between align-items-center min-vh-100 m-0">
        <div className="col-lg-5 auth-left order-lg-1 order-2 py-lg-5">
          <div className="header mb-5">
            <h1>
              Welcome to{' '}
              <Link to="/" className="text-dark">
                B<span className="text-primary2">HEV</span>IN
              </Link>
            </h1>
            <p className="normal mt-3">
              Welcome back, please fill in data to continue
            </p>
          </div>

          <form
            className="auth-form"
            id="authForm"
            onSubmit={(e) => {
              e.preventDefault();
              if (isSame) {
                dispatch(ACTION.login(formData));
                setLoading(true);
              } else {
                Swal.fire({
                  background: '#252336',
                  color: '#3dcd55',
                  title: 'Failed Login!',
                  text: 'Confirm Password must same with Password',
                  confirmButtonColor: '#3dcd55',
                  icon: 'error',
                });
              }
            }}
          >
            <div className="my-4">
              <label
                htmlFor="username"
                className="form-label fw-medium normal mb-2"
              >
                Username
              </label>
              <input
                type="text"
                name="username"
                id="username"
                className="form-control shadow-none px-3 py-2 fw-medium"
                placeholder="eg. user"
                value={formData.username || ''}
                required
                onChange={(el) => {
                  el.preventDefault();
                  formChange('username', el.target.value);
                }}
              />
            </div>

            <div className="my-4">
              <label
                htmlFor="password"
                className="form-label fw-medium normal mb-2"
              >
                Password
              </label>
              <COMPONENT.Input
                type="password"
                idname="password"
                placeholder={'eg. *****'}
                value={formData.password || ''}
                onChange={(val) => {
                  formChange('password', val);
                  setIsSame(formData.confirmPassword === val);
                }}
              />
            </div>

            <div className="my-4">
              <label
                htmlFor="confirmPassword"
                className="form-label fw-medium normal mb-2"
              >
                Confirm Password
              </label>
              <COMPONENT.Input
                type="password"
                className={!isSame ? 'border-danger' : ''}
                idname="confirmPassword"
                placeholder={'eg. *****'}
                onChange={(val) => {
                  formChange('confirmPassword', val);
                  setIsSame(formData.password === val);
                }}
              />
            </div>

            <div className="d-flex align-items-center mt-4 mb-5">
              <div className="position-relative see-password cursor-pointer">
                <input
                  type="checkbox"
                  id="seePassword"
                  name="seePassword"
                  className="form-check-input"
                  onClick={() => setSeePassword(!seePassword)}
                />
                <h5
                  className={`m-0 mt-1 ${seePassword ? 'd-none' : 'd-block'}`}
                  id="hide"
                >
                  <i className="fa-solid fa-eye-slash"></i>
                </h5>
                <h5
                  className={`m-0 mt-1 ${seePassword ? 'd-block' : 'd-none'}`}
                  id="show"
                >
                  <i className="fa-solid fa-eye"></i>
                </h5>
              </div>
              <label
                htmlFor="seePassword"
                className="form-label cursor-pointer fw-semibold normal ms-3 mt-2 user-select-none"
              >
                See Password
              </label>
            </div>

            <button
              type="submit"
              className="button-auth fw-semibold py-25 rounded-3"
              disabled={loading}
            >
              Login
            </button>
            <div className="text-center mt-4">
              <Link
                to="/registration"
                className="fw-medium normal text-primary2"
              >
                Create New Account
              </Link>
            </div>
          </form>
        </div>
        <div className="col-lg-7 p-0 order-lg-2 order-1">
          <div
            id="carouselExampleControls"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active" data-bs-interval="3000">
                <div
                  className="auth-img"
                  style={{
                    backgroundImage: `url(${IMG.AUTH_SLIDE_1})`,
                  }}
                />
              </div>
              <div className="carousel-item" data-bs-interval="3000">
                <div
                  className="auth-img"
                  style={{
                    backgroundImage: `url(${IMG.AUTH_SLIDE_2})`,
                  }}
                />
              </div>
              <div className="carousel-item" data-bs-interval="3000">
                <div
                  className="auth-img"
                  style={{
                    backgroundImage: `url(${IMG.AUTH_SLIDE_3})`,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
